const audioCtx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();

function beep(freq: number, duration: number, gain = 0.4, type: OscillatorType = 'sine'): Promise<void> {
  return new Promise((resolve) => {
    const osc = audioCtx.createOscillator();
    const gainNode = audioCtx.createGain();
    osc.connect(gainNode);
    gainNode.connect(audioCtx.destination);
    osc.type = type;
    osc.frequency.setValueAtTime(freq, audioCtx.currentTime);
    gainNode.gain.setValueAtTime(gain, audioCtx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + duration);
    osc.start(audioCtx.currentTime);
    osc.stop(audioCtx.currentTime + duration);
    osc.onended = () => resolve();
  });
}

export async function playTimerDoneSound(): Promise<void> {
  // Low triple-beep: three descending tones
  await beep(440, 0.3, 0.5, 'square');
  await new Promise((r) => setTimeout(r, 100));
  await beep(370, 0.3, 0.5, 'square');
  await new Promise((r) => setTimeout(r, 100));
  await beep(300, 0.6, 0.5, 'square');
}

export async function playColorTargetSound(): Promise<void> {
  // Ascending chime: three rising tones
  await beep(523, 0.2, 0.4, 'sine');
  await new Promise((r) => setTimeout(r, 80));
  await beep(659, 0.2, 0.4, 'sine');
  await new Promise((r) => setTimeout(r, 80));
  await beep(784, 0.5, 0.4, 'sine');
}

export function resumeAudioContext(): void {
  if (audioCtx.state === 'suspended') {
    audioCtx.resume();
  }
}
